// tslint:disable:max-line-length

import React from 'react';

export const ActionRefresh = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0C6.4,0,4.8,0.5,3.4,1.4c-3.1,2.2-4.3,6.3-2.8,9.7c1.5,3.6,5.4,5.6,9.2,4.7C13.4,15,16,11.7,16,8h-2c0,2.7-2,5.2-4.7,5.8 c-2.8,0.6-5.8-0.9-6.9-3.5c-1-2.5-0.2-5.6,2.1-7.2c2.4-1.6,5.7-1.3,7.7,0.7L10,6h6V0l-2.3,2.3C12.3,1,10.5,0.2,8.7,0 C8.4,0,8.2,0,8,0z" />
    </svg>
  );
};
